import { ReactNode } from 'react'

type ChipGroupProps = {
    heading: string
    showEmptyPlaceholder: boolean
    children: ReactNode
}

const ChipGroup = (props: ChipGroupProps) => {
    const { heading, showEmptyPlaceholder, children } = props

    return (
        <div>
            <div className="text-xs text-grey-dark mb-1">{heading}</div>
            <div className="flex">
                {children}

                {showEmptyPlaceholder && (
                    <div className="flex flex-col justify-center text-xs text-grey-dark">
                        <div>None</div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ChipGroup
